@if (promo?.promo && !isQualiRepar) {
  <sd-tag [tagData]="{theme: themesEnum.promo, text: promo.promo}" />
}
@if (!isQualiRepar) {
  <div class="c__promo-content">
    <span>{{promo.text}}</span>
    @if (promo?.link) {
      <sd-link [link]="promo?.link" (clicked)="onClick()">
        {{promo?.link?.linkName}}
      </sd-link>
    }
  </div>
}
@if (isQualiRepar) {
  <div class="c__promo-content">
    <div class="c__promo-content-left">
      @if (promo?.media) {
        <sd-banner [media]="promo?.media" [isFit]="true" />
      }
      @if (promo?.text) {
        <div class="c__promo-content-info">
          @if (promo?.text) {
            <p class="is-body-s is-bold">{{promo.text}}</p>
          }
          @if (promo?.info) {
            <p class="is-body-s is-medium">{{promo.info}}</p>
          }
        </div>
      }
    </div>
    @if (promo?.modal?.title && promo?.modal?.description) {
      <button sd-button-icon
        type="button"
        class="c__toggle is-full-area {{isOpened ? 'is-open' : ''}}"
        (click)="openModal()"
        [attr.aria-expanded]="isOpened"
        [size]="iconSizeEnum.xs"
        icon="icon-arrow-right"
      ></button>
    }
  </div>
}
@if (promo?.modal?.title && promo?.modal?.description) {
  <sd-modal-default
    [(isOpened)]="isOpened"
    (isOpenedChange)="isOpenedChange.emit($event)"
    [clickToClose]="true"
    modalCustomClass="c__product-promo-modal is-large"
    [titleHidden]="false"
    [modalTitleLevel]="2"
    [modalTitle]="promo?.modal?.title"
  >
    <div class="c__modal-content-info">
      @if (promo?.modal?.media) {
        <sd-banner [media]="promo?.modal?.media" [isFit]="false" />
      }
      <sd-html innerClass="c__modal-content" [html]="promo?.modal?.description" tag="div" />
    </div>
    @if (promo?.modal?.button) {
      <div class="c__modal-actions is-text-right">
        <button sd-button (click)="isOpened = false">
          {{promo?.modal?.button}}
        </button>
      </div>
    }
  </sd-modal-default>
}
